import { APP_VERSION } from "../versions/app-version";

import { storageLangName } from "../localization/const";

export default function ({ $axios, store }, inject) {
  $axios.defaults.timeout = 30000;

  $axios.onRequest((config) => {
    const lang = localStorage.getItem(storageLangName);
    if (lang) config.headers.common["Accept-Language"] = lang;

    if (store.getters['system/getCaptchaHeader']) {
      config.headers.common["daichi-validation-token"] = store.getters['system/getCaptchaHeader'];
    }

    // Иначе в nuxt.config генерируется на сервере один раз при build
    config.headers.common.utcOffset = new Date().getTimezoneOffset() * -1;
  });

  const ax = $axios.create({
    baseURL: process.env.API_URL,
    headers: {
      common: {
        appVersion: APP_VERSION,
        platform: "Web",
      },
    },
  });

  inject("ax", ax);
}
